import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { EmployeesService } from 'src/app/shared/services/employees.service';
import { combineLatest, of } from 'rxjs';
import { switchMap, tap, shareReplay, map } from 'rxjs/operators';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { AdvanceService } from 'src/app/shared/services/advance.service';
import { DelegationService } from 'src/app/shared/services/delegation.service';
import { Delegation } from 'src/app/shared/models/delegation.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Advance } from 'src/app/shared/models/advance.model';
import { ToastrService } from 'ngx-toastr';
import { ApprovalPath } from 'src/app/shared/models/approval-path.model';
import { convertDateToDatMonthNameYearObject } from 'src/app/shared/utils/date.util';
import { UserService } from 'src/app/shared/services/user.service';
import { Employee } from 'src/app/shared/models/employee.model';
import { CostActions } from 'src/app/shared/models/cost-action.model';
import { Cost } from 'src/app/shared/models/cost.model';
import { CostService } from 'src/app/shared/services/cost.service';
import { PrintService } from 'src/app/shared/services/print.service';
import {FileSaverService} from 'ngx-filesaver';

@Component({
  selector: 'app-delegation',
  templateUrl: './delegation.component.html'
})
export class DelegationComponent implements OnInit {

  employees$;
  advances$;
  delegationForm;
  currentUserId: number;
  currentUser: Employee;
  hasCreatedThisCost;
  authEmployeeRoles;

  delegation;
  formattedDateCreatedAt;
  formattedDateUpdatedAt;

  approvalPath: ApprovalPath;

  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private employeeService: EmployeeService,
    private delegationService: DelegationService,
    private toastrService: ToastrService,
    private router: Router,
    private userService: UserService,
    private costService: CostService,
    private printService: PrintService,
    private fs: FileSaverService,
  ) { }

  ngOnInit() {
    const delegationId = parseInt(this.activatedRoute.snapshot.paramMap.get('id'), 10);
    this.currentUser = this.userService.getCurrentUser();
    this.authEmployeeRoles = this.currentUser.user.roles;

    this.createFormGroup();
    this.employees$ = this.employeeService.activeEmployees$;
    this.setupChangeEmployeeAction();


    this.delegationService.fetchDelegation(delegationId).pipe(
      tap(cost => this.patchFormGroup(cost)),

    ).subscribe((delegation: Delegation) => {
      this.delegation = delegation;
      this.formattedDateCreatedAt = convertDateToDatMonthNameYearObject(this.delegation.createdAt);
      if (this.delegation.updatedAt) {
        this.formattedDateUpdatedAt = convertDateToDatMonthNameYearObject(this.delegation.updatedAt);
      }
      // if (delegation.approvalPath) {
      //   this.approvalPath = ApprovalPath.adapt(delegation.approvalPath);
      //   // this.setDisableStatusOnFormGroup();
      // }
      this.hasCreatedThisCost = this.delegation.createdBy.id === this.currentUserId;
    });
  }

  createFormGroup() {
    this.delegationForm = this.fb.group({
      delegationNumber: [null, [Validators.required]],
      employee: [-1],
      grossValue: [null, [Validators.required]],
      advance: [-1],
    });
    // this.delegationForm.get('advance').disable();
  }

  patchFormGroup(delegation) {
    this.delegationForm.patchValue({
      ...delegation,
    });
  }

  setupChangeEmployeeAction() {
    this.advances$ = this.delegationForm.get('employee').valueChanges.pipe(
      tap(v => this.delegationForm.get('advance').setValue(-1)),
      switchMap((employeeId: number) => {
        // this.delegationForm.get('advance').enable();
        if (employeeId && employeeId !== -1) {
          return this.employeeService.fetchAdvances(employeeId);
        } else {
          return of([]);
        }
      }),
      tap((v: Advance[]) => {
        const advanceId = v.length === 1 ? v[0].id : -1;
        this.delegationForm.get('advance').setValue(advanceId);
      })
    );
  }

  changeCostStatus(action: CostActions) {
    this.costService
      .changeCostStatus(this.delegation.id, action, [new Cost(this.delegation.id)])
      .subscribe((response: any) => {
        this.updateCost(response[0]);
        this.toastrService.success('Poprawnie zmieniono status')
      });
  }

  updateCost(response) {
    this.delegation.canCurrentUserMakeAction = response.canCurrentUserMakeAction;
    // this.approvalPath = response.approvalPath ? ApprovalPath.adapt(response.approvalPath) : null;
    this.delegation.status = response.status;
  }

  exportCost() {
    const filename = Date.now() + '.csv';
    this.toastrService.success('Za moment uruchomi się pobieranie pliku do przelewu.');
    this.costService
      .exportToCsv([new Cost(this.delegation.id)])
      .subscribe(result => {
        this.fs.save(result, filename);
      }, _ => this.toastrService.error('Wystąpił problem z wygenerowaniem pliku przelewu.'));
  }

  handleAction(action) {
    switch (action) {
      case 'export':
        this.changeCostStatus(action);
        this.exportCost();
      break;
      case 'return':
        this.changeCostStatus(action);
        break;
    }
  }
}
